import { render, staticRenderFns } from "./UpBtn.vue?vue&type=template&id=0356cf53&scoped=true"
import script from "./UpBtn.vue?vue&type=script&lang=js"
export * from "./UpBtn.vue?vue&type=script&lang=js"
import style0 from "./UpBtn.vue?vue&type=style&index=0&id=0356cf53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0356cf53",
  null
  
)

export default component.exports